export const SELLING_HELP_URL = '/help/52'
